import { useAxios } from '@/context/axiosContext'
import commonUtils from '@/utils/commonUtils'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

type MenuInfoProps = {
  menuPath: string
  onDataCheck?: (hasData: boolean) => void
}

type MenuInfoData = {
  cmpnyCd: string
  menuPath: string
  menuPathSn: number
  code: string
  regId: string
  regDate: string
  updId: string
  updDate: string
  infoSn?: number
  infoSj?: string
  infoCn?: string
  useYn: string
  delYn: string
  infoCnList?: string[]
}

const MenuInfoWrapper = styled.div`
  margin-top: 10px;
  width: 100%;
  max-width: 800px;
  padding-top: 5px;
  padding-left: 16px;
  padding-right: 16px;
`

const AccordionHeader = styled.button`
  width: 100%;
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  padding: 5px 0;
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
`

const InfoList = styled.ul`
  list-style-type: disc;
  padding-left: 15px;
  margin: 0;
`

const InfoItem = styled.li`
  margin-bottom: 4px;
  word-break: break-word; // 긴 단어나 URL이 있을 경우 줄바꿈
  white-space: normal; // 텍스트가 여러 줄로 내려갈 수 있도록
  overflow-wrap: break-word; // 최신 브라우저 지원
`

const MenuInfo: React.FC<MenuInfoProps> = ({ menuPath, onDataCheck }) => {
  const axios = useAxios()
  const [isOpen, setIsOpen] = useState(true)
  const [infoCnList, setInfoCnList] = useState<string[]>([])
  const [infoSj, setInfoSj] = useState<string>()

  useEffect(() => {
    getMenuInfoDetail()
  }, [menuPath])

  const getMenuInfoDetail = async () => {
    const response = await axios.get(`/menu/getMenuInfoDetail`, {
      headers: { 'Cache-Control': 'no-cache' },
      params: {
        menuPath: commonUtils.extractMenuKey(menuPath), //'/notice/list' → 'notice'
      },
    })

    setInfoSj(response.data.data.menuDetail?.infoSj)
    setInfoCnList(response.data.data.menuDetail?.infoCnList)

    //물음표 아이콘 데이터 체크
    if (onDataCheck) {
      onDataCheck(response.data.data.menuDetail?.infoCnList.length > 0)
    }
  }

  if (!infoCnList || infoCnList.length === 0) return null

  return (
    <MenuInfoWrapper>
      <AccordionHeader onClick={() => setIsOpen(!isOpen)}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          {infoSj}
          <img
            src="/svg/true-information-icon.svg"
            alt="caution"
            width={24}
            height={24}
            //style={{ marginRight: '5px' }}
          />
        </div>
      </AccordionHeader>
      {isOpen && (
        // <>
        //   {infoCnList?.map((infoCn, index) => (
        //     <MenuInfoContent key={index}>{infoCn}</MenuInfoContent>
        //   ))}
        // </>

        <InfoList>
          {infoCnList.map((infoCn, idx) => (
            <InfoItem key={idx}>{infoCn}</InfoItem>
          ))}
        </InfoList>
      )}
    </MenuInfoWrapper>
  )
}

export default MenuInfo
